module.exports = __webpack_public_path__ + "img/1552828045.e50b3ea9.jpg";